
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="学校名称">
              <a-input v-model="queryParam.danwei" placeholder="模糊搜索学校名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="学校名称">
              <a-textarea v-model="queryParam.danweis" placeholder="精确搜索学校名称,多个换行"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属地区">
              <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申报状态">
              <a-select v-model="queryParam.registstatus" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">等待审核</a-select-option>
                <a-select-option value="2">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
                <a-select-option value="4">预审核</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

         <a-col :md="6" :sm="24">
           <a-form-item label="申报进度">
             <a-select v-model="queryParam.jindu" placeholder="请选择"
                       allowClear >
               <a-select-option :key="0" value="0">无</a-select-option> 
               <a-select-option :key="6" value="6">授牌</a-select-option> 
             </a-select>
           </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="信息审核">
              <r-switch :formData="queryParam" field="shenhe_status" :checkedValue="1" :unCheckedValue="0"
                        checkedChildren="待审核" unCheckedChildren="不限"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="授牌赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
          <a-col :md="6" :sm="24" v-if="false">
            <a-form-item label="升级赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq2" changeOnSelect/>
            </a-form-item>
          </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="联系人姓名">
                <a-input v-model="queryParam.name" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="联系电话">
              <a-input v-model="queryParam.phone" placeholder="联系电话"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="申报时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>
 </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

<!--    // onDakejianDeleteAll-->
    <div class="table-operator" >
      
      <a-button @click="download(2)" style="margin-left: 8px">
        下载信息表

      <a-icon type="download" />
      </a-button>

      <a-dropdown v-if="  selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <!--          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>-->
          
          <a-menu-item @click="onShoupaiAll(6)" key="3">
             授牌
          </a-menu-item>
          <a-menu-item @click="onShoupaiAll(0)" key="4">
             取消授牌
          </a-menu-item>

          <a-menu-item @click="onEditDoAll(2)" key="3">
             信息审核同意
          </a-menu-item>
          <a-menu-item @click="onEditDoAll(3)" key="4">
             信息审核拒绝
          </a-menu-item>


          <a-menu-item @click="setStatusAll(2)" key="3">
             备案审核同意
          </a-menu-item>
          <a-menu-item @click="setStatusAll(3)" key="4">
             备案审核拒绝
          </a-menu-item>

          <a-menu-item @click="onDakejianDeleteAll" key="1"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button> 
      </a-dropdown> 

      <a-cascader  v-if="selectedRowKeys.length > 0"  :show-search="{ sjsqFilter }" :options="sjsqOptions"
                  :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                  v-model="sjsq" changeOnSelect/>
        <a-button  v-if="selectedRowKeys.length > 0" @click="onSaiquAll()" style="margin-left: 8px">
          批量设置赛区
        </a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            联系人:{{record.name}} <span style="color: #999">手机:{{record.phone}}</span>
            <br/>

            申请时间 {{record.create_time|timeFormat}}<br/>
          授牌赛区:{{ record.saiqu_name }}  <br/>
          <!-- 升级赛区:{{ record.saiqu_name2 }}   -->
          <br />
            <a-tag v-if="record.registstatusdes" color="red"> 未通过原因：{{record.registstatusdes}}</a-tag>

          </div>
      </span>
      <span slot="xiaozhang" slot-scope="text,record">
        校长 {{record.xiaozhang_name}} ({{record.xiaozhang_num}})<br/>
        教师 {{record.jiaoshi_name}} ({{record.jiaoshi_num}})
      </span>
      <span slot="jindu" slot-scope="text,record">

        <a-tag v-if="record.registstatus==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.registstatus==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.registstatus==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a-badge :number-style="{ backgroundColor: '#faad14' }" :count="record.edit_todo_count">
            <a @click="handleEdit(record)">编辑</a>
          </a-badge>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />

          <a-dropdown>
            <a class="ant-dropdown-link">
              下载证书 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item @click="downloadCert(record,0)">实施单位证书</a-menu-item>
              <a-menu-item @click="downloadCert(record,1)">先进个人证书</a-menu-item>
              <a-menu-item @click="downloadCert(record,3)">实施单位证书(带底图)</a-menu-item>
              <a-menu-item @click="downloadCert(record,4)">先进个人证书(带底图)</a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报年度"
                  hasFeedback
              >
                <a-month-picker  v-model="formData.year" placeholder="请选择申报年度" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="省市"
                      hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.namekeys" changeOnSelect
                />
              </a-form-item>
              </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="单位名称"
                      hasFeedback
              >
                <a-input  v-decorator="[
          'danwei',
          {rules: [{ required: true, message: '请输入单位名称' }]}
        ]"
                          placeholder="请输入单位名称"/>
              </a-form-item>
            </a-col>


              </a-row>



          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="全校人数"
                  hasFeedback
          >
            <a-input type="number"  v-decorator="[
          'renshu',
          {rules: [{ required: true, message: '请输入全校人数' }]}
        ]"
                     placeholder="请输入全校人数"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人姓名"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'name',
          {rules: [ ]}
        ]"
                     placeholder="请输入联系人姓名"/>
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机"
                  hasFeedback
          >
            <a-input type="number"  v-decorator="[
          'phone',
          {rules: [ ]}
        ]"
                     placeholder="请输入联系人手机"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
                        <a-form-item
                                :labelCol="labelCol"
                                :wrapperCol="wrapperCol"
                                label="详细地址"
                                hasFeedback
                        >
                          <a-input   v-decorator="[
                        'address',
                        {rules: [ ]}
                      ]"
                                   placeholder="请输入详细地址"/>
                        </a-form-item>
<!--          <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="邮箱"-->
<!--                  hasFeedback-->
<!--          >-->
<!--            <a-input   v-decorator="[-->
<!--          'email',-->
<!--          {rules: [ ]}-->
<!--        ]"-->
<!--                     placeholder="请输入联系人邮箱"/>-->
<!--          </a-form-item>-->
              </a-col>
            </a-row>

<!--          <a-divider>校长信息</a-divider>-->
<!--          <a-row :gutter="48">-->
<!--            <a-col :md="12" :sm="24">-->
<!--          <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="校长姓名"-->
<!--                  hasFeedback-->
<!--          >-->
<!--            <a-input  v-decorator="[-->
<!--          'xiaozhang_name',-->
<!--          {rules: [{ required: true, message: '请输入校长姓名' }]}-->
<!--        ]"-->
<!--                      placeholder="请输入负责人姓名"/>-->
<!--          </a-form-item>-->

<!--            </a-col>-->
<!--            <a-col :md="12" :sm="24">-->
<!--          <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="校长身份证号"-->
<!--                  hasFeedback-->
<!--          >-->
<!--            <a-input  v-decorator="[-->
<!--          'xiaozhang_num',-->
<!--          {rules: [{ required: true, message: '请输入校长身份证号' }]}-->
<!--        ]"-->
<!--                      placeholder="校长身份证号"/>-->
<!--          </a-form-item>-->
<!--              </a-col>-->
<!--            </a-row>-->


          <a-divider>先进个人（教师或校长信息）</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'jiaoshi_name',
          {rules: [{ required: true, message: '请输入姓名' }]}
        ]"
                      placeholder="请输入姓名"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
<!--          <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="教师身份证"-->
<!--                  hasFeedback-->
<!--          >-->
<!--            <a-input  v-decorator="[-->
<!--          'jiaoshi_num',-->
<!--          {rules: [{ required: true, message: '请输入教师身份证' }]}-->
<!--        ]"-->
<!--                      placeholder="请输入教师身份证"/>-->
<!--          </a-form-item>-->

              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="活动照片"
                  hasFeedback
              >
                <pic-uploader
                    :file-list="formData.huodongpic"
                />
              </a-form-item>
              </a-col>
            </a-row>


          <a-divider>审核信息</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  label="领取授牌赛区"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
              >
              {{formData.saiqu_name}}

              <a-select showSearch
                    optionFilterProp="name" style="width:800px" v-model="formData.stationid" placeholder="请选择"
                        allowClear >
                <a-select-option :key="index" v-for="(option,index) in saiquOptions" :value="option.id" :name="option.name">{{option.name}}</a-select-option>
              </a-select>

              </a-form-item>
            </a-col> 
          </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="备案审核"
                  hasFeedback
          >
            <a-radio-group v-model="formData.registstatus" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
              <a-radio-button :value="1">待审核</a-radio-button>
              <a-radio-button :value="2">审核通过</a-radio-button>
              <a-radio-button :value="3">审核失败</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>



          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                :labelCol="{
                  xs: { span: 12 },
                  sm: { span: 4 },
                }"
                :wrapperCol="{
                  xs: { span: 24 },
                  sm: { span: 12 },
                }"
                label="申报进度"
                hasFeedback
              >
                <a-radio-group
                  v-model="formData.jindu"
                  buttonStyle="solid"
                >
                  <a-radio-button :value="0">无</a-radio-button> 
                  <a-radio-button :value="6">授牌</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="管理员备注"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'adminnote',
          {rules: []}
        ]"
                        placeholder="管理员备注"/>
          </a-form-item>
</a-col>
            </a-row>


          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="未通过原因"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'registstatusdes',
          {rules: []}
        ]"
                        placeholder="未通过原因"/>
          </a-form-item>
</a-col>
            </a-row>
        </a-form>

        <a-divider>CCA修改信息审核</a-divider>
        <a-table
                  rowKey="id"
                  :columns="serviceLogColumns"
                  :dataSource="serviceList"
                  :pagination="false"
              >
          <span slot="title1" slot-scope="text,record">
              修改了 {{ record.title }} (<span style="color: #fa8c16; background: #fff7e6;border-color: #ffd591;">
            {{ record.old_name }}
          </span> 修改为
            <span style="color: #fa8c16; background: #fff7e6;border-color: #ffd591;">
              {{ record.new_name }}
            </span>)',
          </span>
                <span slot="status" slot-scope="text,record">
            <a-badge v-if="record.status==1" status="warning" text="待审批"/>
            <a-badge v-else-if="record.status==2" status="success" text="已完成"/>
            <a-badge v-else-if="record.status==3" status="error" text="拒绝"/>
            <a-badge v-else-if="record.status==4" status="default" text="撤销"/>
          </span>
                <span slot="complete_time" slot-scope="text,record">
            提交 {{ record.create_time|timeFormat }}<br/>
            <em v-if="record.complete_time>0">完成 {{ record.complete_time|timeFormat }}</em>
          </span>
                <span slot="actions" slot-scope="text,record,index">
                  <a-popconfirm title="确定同意本操作吗?确定后不恢复" @confirm="handleEditDo(record.id,2)" okText="确定"
                                cancelText="取消">
              <a v-if="record.status==1">同意</a>
                    </a-popconfirm>
    <a-divider type="vertical"/>
                  <a-popconfirm title="确定同意本操作吗?确定后不恢复" @confirm="handleEditDo(record.id,3)" okText="确定"
                                cancelText="取消">
              <a v-if="record.status==1">拒绝</a>
                    </a-popconfirm>
          </span>
              </a-table>


      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');
import { 
  sjsqOptions, 
} from '@/api/sai'

  import{saiquOptions} from '@api/sai'
  import { getDakejianList ,setSaiquAll,setShoupaiAll,setEditDoAll,setStatusAll,getDakejianDetail,editDakejian,deleteDakejian, dakejianDeleteAll,getCDakejianDownloadUrl,editDo } from '@/api/cdakejian'
  import setting from "@/config/setting";
  export default {
    name: 'ExameCenterList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
        saiquOptions:[],
        formData:{
          id:0,
          danwei:'',
          changdipic:[],
          namekeys:[],
          areas:[],
          zhizhaopic:[],
          huodongpic:[],
          shenbaozip:[],
          yanshou_pic:[],
          yanshoubiao_pic:[],
          xflag:[],
          is_tequan:2,
          year: '',
        },
      sjsqOptions: [],
      sjsq:[],
        buyGoodsOptions:[
          {
            "label":"1 标准肋木",
            "value":1
          },
          {
            "label":"2 标准把杆（固定/移动）",
            "value":2
          },
          {
            "label":"3 斜坡啦啦操垫（翻滚）",
            "value":4
          },
          {
            "label":"4 啦啦操训练垫",
            "value":8
          },
          {
            "label":"5 柔韧测试器（髋部）",
            "value":16
          },
          {
            "label":"6 积木式跳箱",
            "value":32
          },
          {
            "label":"7 柔韧测试器（肩部）",
            "value":64
          },
          {
            "label":"8 啦啦操翻腾训练辅助器（组合）A",
            "value":128
          },
          {
            "label":"9 啦啦操翻腾训练辅助器（组合）B",
            "value":256
          },
          {
            "label":"10 七彩星级专用训练考试地胶",
            "value":512
          },
          {
            "label":"11 啦啦操方形蹦床",
            "value":1024
          },
          {
            "label":"12啦啦操专用平衡器",
            "value":2048
          }
        ],
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},
        serviceList:[], 
      serviceLogColumns: [
        {
          title: '说明',
          dataIndex: 'title',
          width: 400,
          scopedSlots: {customRender: 'title1'}
        },
        {
          title: '状态',
          dataIndex: 'admin_status',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: '完成时间',
          dataIndex: 'complete_time',
          scopedSlots: {customRender: 'complete_time'}
        },
        {
          title: '申请人',
          dataIndex: 'apply_user_name',
        },
        {
          title: '操作',
          dataIndex: 'id',
          scopedSlots: {customRender: 'actions'}
        }
      ],

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        shenhe_status: 0,
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '授权编号',
            dataIndex: 'xiaozhang_name',
            scopedSlots: { customRender: 'xiaozhang' },
          },
          {
            title: '进度',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getDakejianList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions() {
        let that = this;
        saiquOptions({
          is_online:2
        }).then(res =>{
          that.saiquOptions = res.data;
        });
        sjsqOptions({}).then(res => {
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getDakejianDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.namekey){
              res.data.namekeys = [res.data.namekey.substring(0,2)+'0000',res.data.namekey.substring(0,4)+'00',res.data.namekey];
            }else{
              res.data.namekeys = [];
            }
            res.data.year = moment(res.data.year,'YYYY-MM');
            self.formData = { ...res.data };

            self.serviceList = res.data.editlist;
          },200)
        })
        // console.log(this.mdl)
      },

      downloadCert(record, type) {
        switch (type) {
          case 0:
            // 实施单位
            window.open(setting.apiBaseURL + '/adminapi/cdakejian/danweiDownload?id=' + record.id);
            break;
          case 1 :
            // 先进个人
            window.open(setting.apiBaseURL + '/adminapi/cdakejian/personDownload?id=' + record.id);
            break;
          case 3:
            // 实施单位
            window.open(setting.apiBaseURL + '/adminapi/cdakejian/danweiDownload?pic=1&id=' + record.id);
            break;
          case 4 :
            // 先进个人
            window.open(setting.apiBaseURL + '/adminapi/cdakejian/personDownload?pic=1&id=' + record.id);
            break;
        }
      },

      deleteHandle(record) {
        let self = this
        deleteDakejian({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

    onShoupaiAll(status){
      let self = this;
      setShoupaiAll({ ids: this.selectedRowKeys ,'status':status })
        .then((res) => {
          self.$message.success("设置成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    onEditDoAll(status){
      let self = this;
      setEditDoAll({ ids: this.selectedRowKeys ,'status':status })
        .then((res) => {
          self.$message.success("操作成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    setStatusAll(status){
      let self = this;
      setStatusAll({ ids: this.selectedRowKeys ,'status':status })
        .then((res) => {
          self.$message.success("操作成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
      onDakejianDeleteAll() {
        let self = this
        dakejianDeleteAll({ ids: this.selectedRowKeys }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editDakejian({
              id:self.formData.id,
              namekey:self.formData.namekeys[self.formData.namekeys.length-1],
              danwei:values.danwei,
              renshu:values.renshu,
              name:values.name,
              phone:values.phone,
              email:values.email,
              xiaozhang_name:values.xiaozhang_name,
              xiaozhang_num:values.xiaozhang_num,
              jiaoshi_name:values.jiaoshi_name,
              jiaoshi_num:values.jiaoshi_num,
              registstatus:self.formData.registstatus,
              stationid:self.formData.stationid,
              registstatusdes:values.registstatusdes,
              jindu:self.formData.jindu,
              adminnote:values.adminnote,
              huodongpic:self.formData.huodongpic,
              address:values.address,
              year: self.formData.year.format('YYYY-MM')
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },

      onMonthChange(value) {
        console.log('onMonthChange', value)
      },

      onSaiquAll(){
        let self = this;
        if(self.sjsq.length<2){ 
            self.$message.error("请先选择赛季赛区");
        }
        setSaiquAll({ ids: this.selectedRowKeys ,'sjsq':self.sjsq })
          .then((res) => {
            self.$message.success("设置成功");
            self.$refs.table.refresh(false);
          })
          .catch((err) => {
            self.$message.error(err.data.msg);
          });
      },

      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
      },

      download(){
        getCDakejianDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

      handleEditDo(id, status) {
      let self = this
      editDo({id: id, status: status}).then(res => {
        self.$message.success('操作成功')
        self.handleEdit({
          id: self.formData.id
        })
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

      sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },

  


    },
    filters:{
      jinduFilter(value){
        switch (value){
          case 1:
            return `联系申报单位`;
          case 2:
            return `告知省级并征求意见+申报单位积极准备中`;
          case 3:
            return `申报单位积极准备中`;
          case 4:
            return `条件已具备，等待验收`;
          case 5:
            return `等待全国啦啦操验收`;
          case 6:
            return `验收并授牌`;
          case 7:
            return `同意考试`;
        }
      },
    },
    watch: {
    }
  }
</script>
